<template>
  <div>
    <section class="pt-[55px] pb-[70px] pc:py-[140px] pc-con-wrapper1">
      <p class="hidden text-lg font-bold text-center pc:text-5xl text-neutral-950 mb-11 pc:block">회원정보수정</p>

      <!-- 비밀번호 확인 게이트: 본인 확인 전에는 회원정보를 노출하지 않는다. -->
      <div v-if="!signUser.isVerified" class="max-w-md mx-auto py-10">
        <p class="mb-5 text-lg font-bold pc:text-2xl text-neutral-950 text-center">비밀번호 확인</p>
        <p class="mb-6 text-sm text-center text-neutral-500">회원정보 수정을 위해 비밀번호를 한 번 더 입력해 주세요.</p>
        <input
          type="password"
          placeholder="비밀번호"
          class="w-full p-4 mb-4 text-sm border border-solid rounded border-neutral-200 placeholder:text-neutral-200 pc:text-base"
          v-model="signUser.verifyPassword"
          @keyup.enter="signUser.checkPassword"
        />
        <p
          class="py-4 text-sm font-bold text-center text-white bg-orange-500 rounded cursor-pointer pc:py-5 pc:text-lg"
          @click="signUser.checkPassword"
        >
          확인
        </p>
      </div>

      <!-- 회원정보 수정 폼: 비밀번호 확인에 성공한 경우에만 노출 -->
      <div v-if="signUser.isVerified">
        <div class="mb-14 pc:mb-36">
          <p class="mb-5 text-lg font-bold pc:text-2xl text-neutral-950 pc:mb-4">회원 정보 : 기본정보</p>
          <ul class="grid grid-cols-1 border-t border-b border-solid divide-y border-neutral-950 divide-solid divide-neutral-200">
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">회원 이름<br class="pc:hidden" />(실명)</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <p class="text-sm font-bold pc:text-base">
                  {{ signUser.userSignInfo.userInfoDataList.kname }}
                </p>
              </div>
            </li>

            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">성별<br class="pc:hidden" /></p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5">
                <ul class="mb-1 flex gap-2">
                  <li class="flex items-center gap-1">
                    <input
                      v-model="signUser.userSignInfo.gender"
                      type="radio"
                      name="gender"
                      id="male"
                      value="M"
                      class="border border-solid border-neutral-200"
                    />
                    <label for="male" class="block">남</label>
                  </li>
                  <li class="flex items-center gap-1">
                    <input
                      v-model="signUser.userSignInfo.gender"
                      type="radio"
                      name="gender"
                      id="female"
                      value="F"
                      class="border border-solid border-neutral-200"
                    />
                    <label for="female" class="block">여</label>
                  </li>
                </ul>
                <p class="text-xs pc:text-base text-neutral-300">* 실제로 수업 받을 학습자 성별을 선택해 주세요.</p>
              </div>
            </li>

            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">이메일 주소</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <p class="text-sm font-bold pc:text-base">
                  {{ signUser.userSignInfo.userInfoDataList.email }}
                </p>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">비밀번호</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <input
                  type="password"
                  placeholder="비밀번호"
                  class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                  v-model="signUser.userSignInfo.userInfoDataList.password"
                  @input="signUser.checkPasswordMatch"
                />
                <p class="text-xs pc:text-base text-neutral-300">
                  * 영문 대/소문자, 숫자, 특수문자를 포함한 8자 이상 입력하세요.
                </p>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">비밀번호 확인</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <div class="flex flex-col gap-2.5">
                  <input
                    type="password"
                    placeholder="비밀번호"
                    class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                    v-model="signUser.userSignInfo.userInfoDataList.passwordCheck"
                    @input="signUser.checkPasswordMatch"
                  />
                  <p
                    class="text-xs font-bold pc:text-base"
                    :class="signUser.passwordMatch && signUser.isPasswordCheckValid ? 'text-purple-600' : 'text-rose-600'"
                    v-if="signUser.showPasswordMessage"
                  >
                    {{
                      signUser.passwordMatch
                        ? signUser.isPasswordCheckValid
                          ? "* 두 비밀번호가 동일합니다."
                          : "* 비밀번호가 유효하지 않습니다."
                        : "* 두 비밀번호가 다릅니다."
                    }}
                  </p>
                </div>
                <p class="text-xs pc:text-base text-neutral-300">
                  * 영문 대/소문자, 숫자, 특수문자를 포함한 8자 이상 입력하세요.
                </p>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">
                  영어이름<br class="pc:hidden" />(수업 이름)
                </p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <input
                  type="text"
                  placeholder="영어이름"
                  class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                  v-model="signUser.userSignInfo.userInfoDataList.ename"
                  @input="signUser.convertToLowerCase"
                />
                <p class="text-xs pc:text-base text-neutral-300">* 수업에서 사용되는 이름입니다.</p>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">휴대전화</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <input
                  type="tel"
                  placeholder="010-1234-5678"
                  class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                  v-model="signUser.userSignInfo.userInfoDataList.mobile"
                  @input="signUser.formatMobile"
                />
                <ul>
                  <li class="text-xs pc:text-base text-neutral-300">
                    * 모든 안내문자와 연락에 사용되는 전화번호입니다. 정확히 기재해 주세요.
                  </li>
                  <li class="text-xs pc:text-base text-neutral-300">
                    * 모든 안내를 학부모님 번호로 받기 희망하시면 학부모님 번호를 기재해 주세요.
                  </li>
                </ul>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">생년월일</p>
              </div>
              <div>
                <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                  <div class="flex gap-2.5 items-center">
                    <select
                      type="text"
                      class="w-32 p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model="signUser.userSignInfo.year"
                    >
                      <option v-for="year in signUser.userSignInfo.years" :key="year">{{ year }}</option>
                    </select>
                    <p>년</p>
                  </div>
                  <div class="flex gap-2.5 items-center">
                    <select
                      type="text"
                      class="w-32 p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model="signUser.userSignInfo.month"
                    >
                      <option v-for="month in signUser.userSignInfo.months" :key="month">{{ month }}</option>
                    </select>
                    <p>월</p>
                  </div>
                  <div class="flex gap-2.5 items-center">
                    <select
                      type="text"
                      class="w-32 p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model="signUser.userSignInfo.day"
                    >
                      <option v-for="day in signUser.userSignInfo.days" :key="day">{{ day }}</option>
                    </select>
                    <p>일</p>
                  </div>
                </div>
                <p class="pl-2.5 pb-3 pc:pl-9 pc:pb-4 text-xs pc:text-base text-neutral-300">
                  * 학습자의 생년월일을 입력해 주세요.
                </p>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">학교 레벨</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <select
                  class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                  v-model="signUser.userSignInfo.userInfoDataList.schoolLevel"
                >
                  <option value="">선택해주세요</option>
                  <option value="미취학">미취학</option>
                  <option value="초등학교">초등학교</option>
                  <option value="중학교">중학교</option>
                  <option value="고등학교">고등학교</option>
                  <option value="성인">성인</option>
                </select>
              </div>
            </li>
            <li
              v-if="
                signUser.userSignInfo.userInfoDataList.schoolLevel !== '미취학' &&
                signUser.userSignInfo.userInfoDataList.schoolLevel !== '성인'
              "
              class="flex items-center"
            >
              <div
                v-if="signUser.userSignInfo.userInfoDataList.schoolLevel !== ''"
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">학교/학년/반</p>
              </div>
              <div
                v-if="signUser.userSignInfo.userInfoDataList.schoolLevel === '초등학교'"
                class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center"
              >
                <ul class="flex flex-col pc:flex-row gap-2.5 pc:gap-9">
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="초등학교"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model="signUser.userSignInfo.userInfoDataList.schoolName"
                      @input="signUser.validateKoreanInput"
                    />
                    <p>초등학교</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="학년"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.userInfoDataList.schoolGrade"
                    />
                    <p>학년</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="반"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.userInfoDataList.schoolClass"
                    />
                    <p>반</p>
                  </li>
                </ul>
              </div>
              <div
                v-if="signUser.userSignInfo.userInfoDataList.schoolLevel === '중학교'"
                class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center"
              >
                <ul class="flex flex-col pc:flex-row gap-2.5 pc:gap-9">
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="중학교"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model="signUser.userSignInfo.userInfoDataList.schoolName"
                      @input="signUser.validateKoreanInput"
                    />
                    <p>중학교</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="학년"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.userInfoDataList.schoolGrade"
                      @input="signUser.onInputNumberOnly"
                    />
                    <p>학년</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="반"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.userInfoDataList.schoolClass"
                      @input="signUser.onInputNumberOnly"
                    />
                    <p>반</p>
                  </li>
                </ul>
              </div>
              <div
                v-if="signUser.userSignInfo.userInfoDataList.schoolLevel === '고등학교'"
                class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center"
              >
                <ul class="flex flex-col pc:flex-row gap-2.5 pc:gap-9">
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="고등학교"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model="signUser.userSignInfo.userInfoDataList.schoolName"
                      @input="signUser.validateKoreanInput"
                    />
                    <p>고등학교</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="number"
                      placeholder="학년"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.userInfoDataList.schoolGrade"
                      @input="signUser.onInputNumberOnly"
                    />
                    <p>학년</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="number"
                      placeholder="반"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.userInfoDataList.schoolClass"
                      @input="signUser.onInputNumberOnly"
                    />
                    <p>반</p>
                  </li>
                </ul>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">주소</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <ul class="flex flex-col gap-2">
                  <li class="flex gap-2">
                    <input
                      type="text"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                      v-model="signUser.userSignInfo.userInfoDataList.postcode"
                      readonly
                      @click="signUser.execDaumPostcode"
                    />
                    <p
                      class="flex-none p-4 text-xs border border-solid rounded cursor-pointer pc:text-base text-neutral-500 bg-neutral-50 border-neutral-200"
                      @click="signUser.execDaumPostcode"
                    >
                      우편번호 찾기
                    </p>
                  </li>
                  <li>
                    <input
                      type="text"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                      v-model="signUser.userSignInfo.userInfoDataList.address"
                      readonly
                      @click="signUser.execDaumPostcode"
                    />
                  </li>
                  <li>
                    <input
                      type="text"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                      v-model="signUser.userSignInfo.userInfoDataList.addressSub"
                    />
                  </li>
                </ul>
              </div>
            </li>
            <!-- 사회적배려대상자 / 영어 레벨테스트 신청 항목 제거: 마이페이지에서 더 이상 노출/수정하지 않음 -->
          </ul>
        </div>

        <!-- 학부모 정보 섹션 제거됨: 학부모 관련 정보(이름/이메일/휴대전화/환불계좌)는 더 이상 마이페이지에서 노출/수정하지 않는다. -->

        <!-- 성인 환불계좌 섹션 제거됨: 마이페이지에서 환불계좌를 더 이상 노출/수정하지 않는다. -->

        <p
          class="max-w-xs py-4 mx-auto text-sm font-bold text-center text-white bg-orange-500 rounded cursor-pointer pc:py-6 pc:text-xl"
          @click="signUser.getUserChangInfo"
        >
          수정하기
        </p>
      </div>
    </section>
  </div>
</template>
<script>
import { reactive, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "@/plugins/axios.js";
import { useStore } from "vuex";

export default {
  components: {},
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const idxLeSiteMain = store.getters.getIdxLeSiteMain;

    const signUser = reactive({
      userSignInfo: {
        address: "", // 주소
        addressSub: "", // 상세 주소
        birthday: computed(() => `${signUser.userSignInfo.year}${signUser.userSignInfo.month}${signUser.userSignInfo.day}`),
        ename: "", // 영어 이름
        email: "", // 이메일
        kname: "", // 한글 이름
        mobile: "", // 휴대폰 번호
        password: "", // 비밀번호
        passwordCheck: "", // 비밀번호 확인
        postcode: "", // 우편번호
        schoolLevel: "", // 학교 레벨
        userInfoDataList: [],
        year: "",
        month: "",
        day: "",
        schoolName: "",
        schoolGrade: "",
        schoolClass: "",
        years: Array.from({ length: 105 }, (_, i) => 1920 + i),
        months: Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0")),
        days: Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, "0")),
        gender: "",
      },

      passwordMatch: false,
      showPasswordMessage: false,

      emailCheck: null,

      isPasswordCheckValid: false,

      // 마이페이지 진입 시 본인 확인 상태
      isVerified: false, // 비밀번호 확인 통과 여부
      verifyPassword: "", // 진입 비밀번호 확인용 입력값 (수정 폼의 password와는 별개)

      // 진입 비밀번호 확인: POST /user/auth/checkPassword 로 본인 확인 후 회원정보를 로드한다.
      checkPassword() {
        if (!signUser.verifyPassword) {
          alert("비밀번호를 입력해 주세요.");
          return;
        }

        axios
          .post(`/user/auth/checkPassword`, { password: signUser.verifyPassword })
          .then(function (res) {
            if (res.data.success === true) {
              signUser.isVerified = true;
              signUser.verifyPassword = ""; // 확인용 입력값은 즉시 폐기
              signUser.getMember(); // 본인 확인 성공 후에만 회원정보 로드
            } else {
              alert(res.data.message);
            }
          })
          .catch(function (err) {
            alert(err.response?.data?.message || "비밀번호 확인에 실패했습니다.");
          });
      },

      validateKoreanInput(e) {
        var regexp = /[a-zA-Z0-9]|[ \[\]{}()<>?|`~!@#$%^&*-_+=,.;:\"'\\]/g;

        if (regexp.test(e.target.value)) {
          alert("한글만 입력해주세요.");
          e.target.value = e.target.value.replace(regexp, "");
        }
      },

      checkPasswordMatch() {
        signUser.passwordMatch =
          signUser.userSignInfo.userInfoDataList.password === signUser.userSignInfo.userInfoDataList.passwordCheck;

        const passwordRegex = /^(?=.*\d)(?=.*[~`!@#$%\^&*()-])(?=.*[a-zA-Z]).{8,15}$/;
        const isPasswordCheckValid = passwordRegex.test(signUser.userSignInfo.userInfoDataList.passwordCheck);

        signUser.showPasswordMessage =
          signUser.userSignInfo.userInfoDataList.password?.length > 0 ||
          signUser.userSignInfo.userInfoDataList.passwordCheck?.length > 0;
        this.isPasswordCheckValid = isPasswordCheckValid;
      },

      convertToLowerCase() {
        const input = signUser.userSignInfo.userInfoDataList.ename;

        if (/[ㄱ-ㅎㅏ-ㅣ가-힣\d]/.test(input)) {
          alert("영어 이름은 영어만 입력 가능합니다.");
          signUser.userSignInfo.userInfoDataList.ename = input.replace(/[^a-zA-Z]/g, "");
        } else {
          signUser.userSignInfo.userInfoDataList.ename = input.toLowerCase();
        }
      },

      formatMobile() {
        // DOM(e.target.value)을 직접 조작하면 v-model의 reactive state(mobile)와 어긋나
        // 모바일 IME 환경에서 하이픈 없는 값이 state에 남아 검증에 실패한다.
        // 회원가입(signUp3)과 동일하게 reactive state를 읽어 포맷 후 다시 state에 반영한다.
        let input = signUser.userSignInfo.userInfoDataList.mobile;
        let numericValue = input.replace(/\D/g, "");
        let formattedValue = numericValue.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        signUser.userSignInfo.userInfoDataList.mobile = formattedValue.slice(0, 13);
      },

      execDaumPostcode() {
        new window.daum.Postcode({
          oncomplete: (data) => {
            signUser.userSignInfo.userInfoDataList.postcode = data.zonecode;
            let buildingName = data.buildingName ? ` (${data.buildingName})` : "";
            signUser.userSignInfo.userInfoDataList.address = data.roadAddress + buildingName;
            // signUser.userSignInfo.addressSub = data.jibunAddress;
          },
        }).open();
      },

      // 학부모 이메일 조립/분해 헬퍼(updateParentEmail/devideParentEmail)는
      // 마이페이지에서 학부모 정보가 제거되어 더 이상 사용하지 않으므로 삭제함.

      getMember() {
        axios.get(`/user/sugang/member`).then(function (res) {
          if (res.data.success === true) {
            signUser.userSignInfo.userInfoDataList = res.data.data;
            signUser.userSignInfo.year = res.data.data.birthday.substring(0, 4);
            signUser.userSignInfo.month = res.data.data.birthday.substring(4, 6);
            signUser.userSignInfo.day = res.data.data.birthday.substring(6, 8);
            signUser.userSignInfo.gender = res.data.data.gender;
            // 학부모 정보는 마이페이지에서 다루지 않으므로 학부모 이메일 파싱(devideParentEmail) 제거
          } else {
            alert(res.data.message);
          }
        });
      },

      getUserChangInfo() {
        if (!signUser.userSignInfo.userInfoDataList.password) {
          alert("비밀번호를 입력해주세요.");
          return;
        }

        if (!signUser.userSignInfo.userInfoDataList.passwordCheck) {
          alert("비밀번호를 확인해주세요.");
          return;
        }

        if (!signUser.userSignInfo.userInfoDataList.ename) {
          alert("영어이름을 입력해주세요");
          return;
        }

        if (!signUser.userSignInfo.userInfoDataList.mobile) {
          alert("휴대전화 번호를 입력해주세요.");
          return;
        }

        if (!signUser.userSignInfo.userInfoDataList.schoolLevel) {
          alert("학교 레벨을 선택해주세요");
          return;
        }

        // 사업부 요청(2026-07-13): 우편번호/주소/상세주소를 모두 필수값으로 강제.
        // 회원가입(signUp3)에는 적용됐으나 마이페이지가 누락되어, AND 조건 탓에
        // 셋 다 비어야만 경고가 떴다 → 우편번호나 주소만 비운 저장이 통과해
        // 결제 승인 단계에서 거부되는 회원이 생겼다. signUp3와 동일 기준으로 맞춘다.
        // 우편번호·주소는 "우편번호 찾기"(다음 우편번호 API)로 함께 채워지고,
        // 상세주소만 사용자가 직접 입력한다.
        if (
          !signUser.userSignInfo.userInfoDataList.postcode ||
          !signUser.userSignInfo.userInfoDataList.address
        ) {
          alert("우편번호 찾기를 통해 주소를 입력해주세요.");
          return;
        }

        if (!signUser.userSignInfo.userInfoDataList.addressSub) {
          alert("상세주소를 입력해주세요.");
          return;
        }

        const mobileRegex = /^010-\d{3,4}-\d{4}$/;
        if (!mobileRegex.test(signUser.userSignInfo.userInfoDataList.mobile)) {
          alert("휴대폰 번호를 다시 확인해주세요.");
          return;
        }

        const params = {
          ...signUser.userSignInfo,
          ...signUser.userSignInfo.userInfoDataList,
          birthday: `${signUser.userSignInfo.year}${signUser.userSignInfo.month}${signUser.userSignInfo.day}`,
          gender: signUser.userSignInfo.gender,
        };

        // 마이페이지에서 제거된 항목은 저장 페이로드에서도 모두 제외한다.
        // - 학부모 정보(이름/이메일/휴대전화)
        // - 환불계좌(parentBank/parentBankAccountHolder/parentBankNumber) — 성인 환불계좌 섹션 제거됨
        // - 사회적배려대상자(socialConsideration), 영어 레벨테스트 신청(isLevelTest)
        delete params.parentName;
        delete params.parentEmail;
        delete params.parentId;
        delete params.parentSelectEmail;
        delete params.parentCustomDomain;
        delete params.parentMobile;
        delete params.parentBank;
        delete params.parentBankAccountHolder;
        delete params.parentBankNumber;
        delete params.socialConsideration;
        delete params.isLevelTest;

        axios.put(`/user/sugang/member/register`, params).then(function (res) {
          if (res.data.success === true) {
            alert("회원정보 수정이 완료 되었습니다.");
            router.push({
              path: "/home",
            });
          } else {
            alert(res.data.message);
          }
        });
      },
    });

    onMounted(() => {
      // 회원정보는 비밀번호 확인(checkPassword) 성공 후에 로드한다. 진입 시 자동 조회하지 않는다.
    });

    return {
      signUser,
    };
  },
};
</script>
<style scoped></style>
